import React from "react";
import { useTranslation } from "react-i18next";
import { CollapseButton } from "../../../CollapseButton/CollapseButton";
import { FundListFilterItem } from "../../FundListFilterItem";

import useStyles from "../../FundList.style";

export interface FundListExpandedButtonProps {
  isAccordionExpanded: boolean;
  onExpand: () => void;
  autoTestId?: string;
}

export const FundListExpandedButton = ({
  isAccordionExpanded,
  onExpand,
  autoTestId,
}: FundListExpandedButtonProps) => {
  const c = useStyles({});
  const [t] = useTranslation("components");
  return (
    <FundListFilterItem className={c.accordionExpandAction}>
      <CollapseButton
        className={c.accordionTitle}
        onClick={onExpand}
        expanded={isAccordionExpanded}
        aria-label={
          isAccordionExpanded
            ? t("fund-list.less-filters-aria-label")
            : t("fund-list.more-filters-aria-label")
        }
        testId="FundListExpandedButton"
        autoTestId={autoTestId}
      >
        {isAccordionExpanded
          ? t("fund-list.less-filters")
          : t("fund-list.more-filters")}
      </CollapseButton>
    </FundListFilterItem>
  );
};
